import React from 'react';

export const ForgePioHelpjuiceSearchResultIcon = () => {
	return (
		<svg
			width="32"
			height="32"
			viewBox="0 0 14 14"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			aria-hidden="true"
			focusable="false"
		>
			<path
				d="M7.266 5.959c-.588.555-.956 1.343-.956 2.217 0 .687.227 1.32.609 1.828l-1.16 1.167a1.01 1.01 0 0 0-.328-.059c-.253 0-.49.098-.668.277a.95.95 0 0 0-.277.67c0 .253.098.49.277.668.178.178.417.272.668.272.253 0 .49-.092.67-.272.178-.178.277-.417.277-.668 0-.098-.014-.192-.045-.284l1.172-1.177c.516.396 1.158.63 1.859.63 1.685 0 3.047-1.366 3.047-3.052 0-1.528-1.118-2.794-2.583-3.016V3.53c.41-.173.661-.558.661-1.006 0-.612-.49-1.123-1.102-1.123-.612 0-1.095.511-1.095 1.123 0 .448.251.832.661 1.006v1.434a3.13 3.13 0 0 0-1 .319C5.18 4.793 3.073 3.274 1.868 2.358a1.13 1.13 0 0 0 .047-.323c0-.675-.551-1.223-1.228-1.223-.675 0-1.223.548-1.223 1.223 0 .677.548 1.226 1.223 1.226.23 0 .443-.068.628-.178l3.825 2.688zm2.098 3.834c-.893 0-1.617-.724-1.617-1.617 0-.893.724-1.617 1.617-1.617.893 0 1.617.724 1.617 1.617 0 .893-.724 1.617-1.617 1.617z"
				fill="#000"
			/>
		</svg>
	);
};
